import { TooltipProps } from 'primereact/tooltip';

// Flip the tooltip to the left of the pointer when it sits in the right half.
export const alignTooltipToPointer: NonNullable<
  TooltipProps['onBeforeShow']
> = (event) => {
  const { clientX } = event.originalEvent as unknown as MouseEvent;
  event.target.setAttribute(
    'data-pr-position',
    clientX > window.innerWidth / 2 ? 'left' : 'right'
  );
};
